<template>
	<div class="ticker-message">
		<div class="ticker-message--icon" :style="{backgroundColor: $config.public.colors.light_gray}">
			<Icon :icon="icon" small :color="$config.public.colors.text"/>
		</div>
		<card class="ticker-message--content" outlined>
			<card-title>
				<skeleton :height="14" :width="100" rounded/>
			</card-title>
			<card-text>
				<skeleton :height="14" class="mb-4" :min-width="100" :max-width="300" rounded/>
				<skeleton :height="14" class="mb-4" :min-width="100" :max-width="300" rounded/>
				<skeleton :height="14" class="mb-4" :min-width="100" :max-width="300" rounded/>
			</card-text>
		</card>
	</div>
</template>

<script>
import {mdiMessageTextOutline} from "@mdi/js";

export default {
	name: "TickerMessageSkeleton",

	data() {
		return {
			icon: mdiMessageTextOutline
		}
	}
}
</script>


<style>
/*********************
  Inputs
**********************/
.ticker-feed.ticker-feed--live .ticker-message:first-child .ticker-message--icon {
  box-shadow: 0 0 0 rgba(71, 164, 71, 0.4);
  animation: pulse 2s infinite;
}
.ticker-feed.ticker-feed--live .ticker-message:first-child .ticker-message--icon:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(71, 164, 71, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(71, 164, 71, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(71, 164, 71, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(71, 164, 71, 0.4);
    box-shadow: 0 0 0 0 rgba(71, 164, 71, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(71, 164, 71, 0);
    box-shadow: 0 0 0 10px rgba(71, 164, 71, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(71, 164, 71, 0);
    box-shadow: 0 0 0 0 rgba(71, 164, 71, 0);
  }
}

.ticker-message {
  display: flex;
  margin-bottom: 8px;
}
.ticker-message .ticker-message--content {
  max-width: 100%;
  width: 480px;
}
.ticker-message .ticker-message--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: -52px;
  margin-right: 16px;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 0 0 6px #fff;
}
</style>